<div class="p-6">
  <!-- Page Header -->
  <div class="mb-6">
    <h1 class="text-heading-xl mb-2">{{ 'users.title' | translate }}</h1>
    <p class="text-body-md text-secondary">{{ 'users.subtitle' | translate }}</p>
  </div>

  <!-- Users Table -->
  <p-table 
    #table
    [value]="displayData()" 
    [loading]="false"
    [paginator]="!loading()" 
    [rows]="rows"
    [totalRecords]="totalRecords()"
    [first]="first"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [globalFilterFields]="['email', 'username']"
    [stripedRows]="true"
    [tableStyle]="{'table-layout': 'fixed', 'width': '100%'}">
    
    <!-- Table Caption with Search and Add Button -->
    <ng-template pTemplate="caption">
      <div class="flex">
        <div class="flex gap-2">
          @if (loading()) {
            <p-skeleton width="8rem" height="2.5rem"></p-skeleton>
          } @else {
            <p-button 
              label="{{ 'users.addUser' | translate }}"
              icon="pi pi-plus"
              severity="success"
              [disabled]="loading()"
              (onClick)="addUser()">
            </p-button>
          }
        </div>
        <p-iconfield iconPosition="left" class="ml-auto">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          @if (loading()) {
            <p-skeleton width="12rem" height="2.5rem"></p-skeleton>
          } @else {
            <input 
              pInputText 
              type="text" 
              [disabled]="loading()"
              (input)="table.filterGlobal($any($event.target).value, 'contains')" 
              [placeholder]="'users.searchPlaceholder' | translate" />
          }
        </p-iconfield>
      </div>
    </ng-template>
    
    <!-- Table Header -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="email" class="w-2/5">
          {{ 'users.email' | translate }}
          <p-sortIcon field="email"></p-sortIcon>
        </th>
        <th pSortableColumn="username" class="w-2/5">
          {{ 'users.username' | translate }}
          <p-sortIcon field="username"></p-sortIcon>
        </th>
        <th class="w-1/5">{{ 'users.actions' | translate }}</th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-user>
      <tr>
        <td>
          @if (loading()) {
            <p-skeleton width="100%" height="1.25rem"></p-skeleton>
          } @else {
            {{ user.email }}
          }
        </td>
        <td>
          @if (loading()) {
            <p-skeleton width="100%" height="1.25rem"></p-skeleton>
          } @else {
            {{ user.username }}
          }
        </td>
        <td>
          @if (loading()) {
            <div class="flex gap-2">
              <p-skeleton shape="circle" size="2rem"></p-skeleton>
              <p-skeleton shape="circle" size="2rem"></p-skeleton>
            </div>
          } @else {
            <div class="flex gap-2">
              <p-button 
                icon="pi pi-pencil" 
                [rounded]="true"
                size="small"
                [ariaLabel]="'users.edit' | translate"
                (onClick)="editUser(user)">
              </p-button>
              <p-button 
                icon="pi pi-trash" 
                [rounded]="true"
                size="small"
                [ariaLabel]="'users.delete' | translate"
                (onClick)="deleteUser(user)">
              </p-button>
            </div>
          }
        </td>
      </tr>
    </ng-template>

    <!-- Empty state -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center py-8">
          <div class="flex flex-col items-center gap-3">
            <i class="pi pi-users text-4xl text-muted"></i>
            <p class="text-body-md text-muted">{{ 'users.noData' | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Confirmation Dialog -->
  <p-confirmDialog></p-confirmDialog>
  
  <!-- Toast Messages -->
  <p-toast></p-toast>
</div>